import {EVENTS, URLS} from "../constants";
import Logger from "../logger";

export default class BaseForm extends Logger {
	constructor() {
		super();

		this.options = this.defaultOptions();
	}

	defaultOptions() {
		return {
			container: "",
			ajaxUrl: "",
		};
	}

	setOptions(options) {
		this.options = Object.assign(this.defaultOptions(), options);

		this.initContainer();
	}

	initContainer() {
		if (this.options.container) {
			this.obHtml = $(this.options.container);
		} else {
			$("body").append($("<div id='efpbInternalContainer' style='display:none;'></div>"));
			this.options.container = "#efpbInternalContainer";

			this.obHtml = $(this.options.container);
		}
	}

	init(options) {
		this.setOptions(options);

		if (this.obHtml.length <= 0) {
			return;
		}

		this.loadComponent(this.getLoadComponentParams());
	}

	getLoadComponentParams() {
		return {};
	}

	loadComponent(data) {
		BX.ajax({
			url: this.options.ajaxUrl,
			method: "post",
			dataType: "html",
			async: true,
			processData: true,
			emulateOnload: true,
			start: true,
			scriptsRunFirst: true,
			data: data,
			onsuccess: (result) => {
				if (result) {
					this.obHtml.html(result);

					setTimeout(() => {
						BX.onCustomEvent(EVENTS.VUE_INIT);
					}, EVENTS.VUE_INIT_TIMEOUT);
				} else {
					this.logError(result);
				}
			},
			onfailure: (type, e) => {
				this.logError(e);
			}
		});
	}
}